import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import Overlay from './Overlay';
import styled from 'styled-components';

const OverlayClickSurface = styled.div`
	width: 100%;
	height: 100%;
`;

interface IOverlayProps {
	children: React.ReactNode; // children can be any valid React node (string, JSX, other components, etc.)
	onOverlayClick?(): void;
}
export default function PopUp({ children, onOverlayClick }: IOverlayProps) {

	const [portalContainer, setPortalContainer] = useState<Element | null>(null);

	useEffect(() => {
		const portalContainer = document.getElementById('root');
		if (portalContainer) {
			setPortalContainer(portalContainer);
		}
	}, []);

	const overlayClick = useCallback(
		() => {
			if (onOverlayClick) {
				onOverlayClick();
			}
		},
		[onOverlayClick],
	);

	const renderContent = useCallback(
		() => {
			return (
				<Overlay>
					<OverlayClickSurface onClick={overlayClick}/>
					{children}
				</Overlay>
			);
		},
		[children, overlayClick],
	);

	if (portalContainer) {
		return ReactDOM.createPortal(
			renderContent(),
			portalContainer
		);
	} else {
		return null;
	}
}
